module.exports = __webpack_public_path__ + "media/sitemap_page/images/btn_dropdown_close-78f5a59cc9f2242ecee08f5e7292e538.png";